import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
ChartJS.register(ArcElement, Tooltip, Legend);

const CourseChart = ({ students, courses, backgroundColor, borderColor }) => {
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
                text: 'Students Enrolled in your Courses',
            },
        },
    };
    const data = {
        labels: courses,
        datasets: [
            {
                label: '# Enrolled Students',
                data: students,
                backgroundColor,
                borderColor,
                borderWidth: 1,
            },
        ],
    };

    return (
        <div className='flex flex-col items-center justify-center w-full relative aspect-square h-full'>
            <Pie options={options} data={data} />
        </div>
    );
}

export default CourseChart;